import { useSelector } from 'react-redux';
import { getFirstProfileIdFromAccountSummary } from '../../../core/util/account';

export default (params: any) => {
  const { userProfileId } = params;

  const firstUserProfileId = useSelector(
    (state: any) => userProfileId || getFirstProfileIdFromAccountSummary(state.account.summary)
  );

  return userProfileId || firstUserProfileId;
};
